module.exports = __webpack_public_path__ + "static/img/2.10720bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/commonality/20240725/2.jpg
// module id = 4S09
// module chunks = 7